const isMobile = () =>
  typeof document !== "undefined"
    ? document.documentElement.clientWidth <= 768
    : null

export default isMobile
